import React from 'react';
import Checkbox from '../../../../../components/Common/UI/Checkbox';
import { cn } from '../../../../../utils/styles';

interface IGuidanceCheckBox {
  id: string;
  label: string | React.ReactNode;
  checked?: boolean;
  onClick?: () => void;
  checkBoxStyle?: string;
  wrapStyle?: string;
  labelStyle?: string;
}

function GuidanceCheckBox({ onClick, id, label, checked, checkBoxStyle, wrapStyle, labelStyle }: IGuidanceCheckBox) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick?.();
  };

  return (
    <div className={cn('flex gap-[15px] items-center', wrapStyle)}>
      <Checkbox
        id={id}
        variant="guidance"
        onClick={handleClick}
        checked={checked}
        className={checkBoxStyle}
        type="button"
      />
      <label
        htmlFor={id}
        className={cn('uppercase text-addition1 text-[12px] font-medium opacity-80 cursor-pointer', labelStyle)}
      >
        {label}
      </label>
    </div>
  );
}

GuidanceCheckBox.defaultProps = {
  checked: undefined,
  checkBoxStyle: '',
  wrapStyle: '',
  labelStyle: '',
  onClick: () => undefined,
};

export default GuidanceCheckBox;
